import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import TextInput from 'components/atoms/form/TextInput/TextInput'
import ToggleSwitch from 'components/atoms/form/ToggleSwitch/ToggleSwitch'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import RouteConst from 'constants/RouteConst'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import HotelChargesService from 'services/HotelChargesService'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import {isArrayNotEmpty, isCompletedHotelInfoHistory, isObjectEmpty, searchFirstObjectInList} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Card from '../../../molecules/Card/Card'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './TaxesAndCharges.scss'

class TaxesAndCharges extends Component {

  constructor(props) {
    super(props)

    const isHotelDomestic = getSessionItem(SessionConst.IS_HOTEL_DOMESTIC)
    let chargeFrequencyOptions
    const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY);

    if (isHotelDomestic === FormConst.VALUE_YES) {
      chargeFrequencyOptions = FormConst.TAXES_CHARGE_FREQUENCY_TYPE_DOMESTIC
    } else {
      chargeFrequencyOptions = FormConst.TAXES_CHARGE_FREQUENCY_TYPE_INTERNATIONAL
    }

    this.state = {
      hotelCode: getSessionItem(SessionConst.HOTEL_CODE),
      hotelInfo: getSessionItem(SessionConst.HOTEL_INFO),
      hotelCurrency: getSessionItem(SessionConst.HOTEL_CURRENCY),
      extraCharges: [],
      error: undefined,
      isLoading: true,
      loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
      showErrorModal: false,
      initialValues: this.initialValues,
      showUpdateModal: false,
      chargeFrequencyOptions: chargeFrequencyOptions,
      hotelInfoCompletedHistory: hotelInfoCompletedHistory,
      isHotelDomestic: isHotelDomestic
    }
  }

  taxesAndChargesLabels = {
    PERCENTAGE_TAX: 'Tax Percentage',
    FLAT_TAX: 'Flat Taxes',
    HOTEL_FEES: 'Additional Hotel Fees'
  }

  initialValues = {
    percentTax: 0,
    percentTaxFrequency: FormConst.VALUE_PER_ROOM_PER_NIGHT,
    isFlatTax: false,
    flatTax: 0,
    flatTaxFrequency: '',
    isHotelFees: false,
    hotelFees: 0,
    hotelFeesFrequency: ''
  }

  validationSchema = Yup.object().shape({
    percentTax: Yup.number()
      .typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER)
      .required(FormConst.VALIDATION_ERROR_REQUIRED)
      .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO),
    percentTaxFrequency: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
    isFlatTax: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
    flatTax: Yup.number()
      .when('isFlatTax', {
        is: (isFlatTax) => isFlatTax === true,
        then: Yup.number()
          .typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER)
          .required(FormConst.VALIDATION_ERROR_REQUIRED)
          .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
      }),
    flatTaxFrequency: Yup.string()
      .when('isFlatTax', {
        is: (isFlatTax) => isFlatTax === true,
        then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
      }),
    isHotelFees: Yup.boolean().required(FormConst.VALIDATION_ERROR_REQUIRED),
    hotelFees: Yup.number()
      .when('isHotelFees', {
        is: (isHotelFees) => isHotelFees === true,
        then: Yup.number()
          .typeError(FormConst.VALIDATION_ERROR_TYPE_NUMBER)
          .required(FormConst.VALIDATION_ERROR_REQUIRED)
          .min(0.0001, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_ZERO),
      }),
    hotelFeesFrequency: Yup.string()
      .when('isHotelFees', {
        is: (isHotelFees) => isHotelFees === true,
        then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
      })
  })

  handleSubmit = (formData) => {
    let hotelCharges = []

    const percentageTax = {
      code: FormConst.HOTEL_CHARGE_CODE_PERCENTAGE_TAX,
      description: FormConst.HOTEL_CHARGE_DESCRIPTION_PERCENTAGE_TAX,
      amountType: FormConst.HOTEL_CHARGE_AMOUNT_TYPE_PERCENT,
      percentageRate: formData.percentTax
    }

    hotelCharges.push(percentageTax)

    if (formData.isFlatTax) {
      const flatTax = {
        code: FormConst.HOTEL_CHARGE_CODE_FLAT_TAX,
        description: FormConst.HOTEL_CHARGE_DESCRIPTION_FLAT_TAX,
        amountType: FormConst.HOTEL_CHARGE_AMOUNT_TYPE_FIXED,
        fixedAmount: formData.flatTax,
        frequency: formData.flatTaxFrequency
      }
      hotelCharges.push(flatTax)
    }

    if (formData.isHotelFees) {
      const hotelFees = {
        code: FormConst.HOTEL_CHARGE_CODE_HOTEL_FEES_TAX,
        description: FormConst.HOTEL_CHARGE_DESCRIPTION_HOTEL_FEES_TAX,
        amountType: FormConst.HOTEL_CHARGE_AMOUNT_TYPE_FIXED,
        fixedAmount: formData.hotelFees,
        frequency: formData.hotelFeesFrequency
      }
      hotelCharges.push(hotelFees)
    }

    const putData = {
      hotelCode: this.state.hotelCode,
      hotelCharges: hotelCharges
    }

    this.props.onPut(putData)
    this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
  }

  async componentDidMount() {
    if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
      let hotelCharges = this.state.hotelInfoCompletedHistory.newEntity?.hotelCharges?.hotelCharges;
      this.setState({
        hotelCharges: hotelCharges,
        initialValues: this.buildFormValues(hotelCharges),
        isLoading: false
      })
    } else {
      await HotelChargesService.getHotelTaxes({ hotelCode: this.state.hotelCode })
        .then(response => {
          this.setState({
            hotelCharges: response.hotelCharges,
            initialValues: this.buildFormValues(response.hotelCharges),
            isLoading: false
          })
        }).catch(error => {
          this.setState({
            errorMessage: 'There was an error while retrieving Hotel Charges data',
            showErrorModal: true,
            isLoading: false
          })
        })
    }

  }

  buildFormValues = (hotelCharges) => {

    let initialValues = {
      ...this.initialValues
    }
    if (isArrayNotEmpty(hotelCharges)) {
      const percentTax = searchFirstObjectInList('code', FormConst.HOTEL_CHARGE_CODE_PERCENTAGE_TAX, hotelCharges)
      const flatTax = searchFirstObjectInList('code', FormConst.HOTEL_CHARGE_CODE_FLAT_TAX, hotelCharges)
      const hotelFees = searchFirstObjectInList('code', FormConst.HOTEL_CHARGE_CODE_HOTEL_FEES_TAX, hotelCharges)

      const isFlatTax = !isObjectEmpty(flatTax)
      const isHotelFees = !isObjectEmpty(hotelFees)

      initialValues = {
        percentTax: percentTax?.percentageRate,
        percentTaxFrequency: FormConst.VALUE_PER_ROOM_PER_NIGHT,
        isFlatTax: isFlatTax,
        flatTax: isFlatTax ? flatTax.fixedAmount : 0,
        flatTaxFrequency: isFlatTax ? flatTax.frequency : '',
        isHotelFees: isHotelFees,
        hotelFees: isHotelFees ? hotelFees.fixedAmount : 0,
        hotelFeesFrequency: isHotelFees ? hotelFees.frequency : ''
      }
    }

    return initialValues
  }

  componentDidUpdate(prevProps) {
    if (prevProps.count !== this.props.count) {
      if (this.props.errorMessage) {
        this.setState({
          isLoading: false,
          errorMessage: this.props.errorDescription,
          showErrorModal: true
        })
      } else {
        this.props.history.push(RouteConst.ROUTE_EXTRA_CHARGES_PAGE)
      }
    }
  }

  handleClearForm = () => {
    this.setState({ showResetModal: true })
  }

  resetFormData = (formikResetFormMethod) => {
    formikResetFormMethod()
    this.setState({
      showResetModal: false
    })
  }

  render() {
    return (
      <Formik
        initialValues={this.state.initialValues}
        validationSchema={this.validationSchema}
        enableReinitialize={true}
        onSubmit={(data, { setSubmitting }) => {
          setSubmitting(true)
          this.handleSubmit(data)
          setSubmitting(false)
        }}
        onReset={this.handleReset}>
        {({ values, isSubmitting, isValid, handleChange, handleSubmit, setFieldValue, handleBlur, dirty, errors, resetForm }) => (
          <Form>

            <div className='taxes-and-charges-form-fields'>

              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
                  <li className="breadcrumb-item active" aria-current="page">Taxes and Charges</li>
                </ol>
              </nav>

              <p className='helper-text'>{this.state.isHotelDomestic === FormConst.VALUE_YES ? FormConst.HOTEL_TAXES_HELPER_TEXT_DOMESTIC : FormConst.HOTEL_TAXES_HEPLER_TEXT}</p>
              {/* PERCENTAGE_TAX card */}
              <Card
                id='tax-percentage'
                header={this.taxesAndChargesLabels.PERCENTAGE_TAX}
                footer='Percentage Tax is mandatory'
                text={
                  <Row className='justify-content-start'>
                    <Col xs={12} sm={12} md={6} lg={6} xl={5}>
                      <TextInput
                        id='percent-tax'
                        name='percentTax'
                        type='number'
                        min='0'
                        step='1'
                        max='100'
                        placeholder='0'
                        label='Percentage Amount* (%)' />
                    </Col>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                      Charge Frequency is {values.percentTaxFrequency}.
                    </Col>
                  </Row>
                } />
              {/* FLAT_TAX card */}
              { !(this.state.isHotelDomestic === FormConst.VALUE_YES) &&
                <p className='helper-text flat-tax-text'>Charge frequency will be same for Flat Taxes and Additional Hotel Fees.</p>
              }
              <Card
                id='flat-taxes'
                header={this.taxesAndChargesLabels.FLAT_TAX}
                text={
                  <Row className='justify-content-start'>
                    <Col xs={12} sm={12} md={6} lg={6} xl={4}>
                      <ToggleSwitch
                        id='isFlatTax'
                        name='isFlatTax'
                        label='Do you want to add flat tax?'
                        checked={values.isFlatTax}
                        value={values.isFlatTax}
                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                        onChange={handleChange} />
                    </Col>

                    {
                      values.isFlatTax &&
                      (
                        <>
                          <Col xs={12} sm={12} md={6} lg={6} xl={4}>
                            <TextInput
                              id='flat-tax-amount'
                              name='flatTax'
                              type='number'
                              min='0'
                              step='0.5'
                              max='2500'
                              placeholder='0'
                              label={`Flat Amount* (${this.state.hotelCurrency})`} />
                          </Col>
                          <Col xs={12} sm={12} md={6} lg={6} xl={4} className='wide-item'>
                            <SelectInput
                              id='flat-tax-frequency'
                              name='flatTaxFrequency'
                              label='Charge Frequency'
                              options={this.state.chargeFrequencyOptions}
                              onInput={(e) => {
                                e.preventDefault()
                                values.hotelFeesFrequency = e.target.value
                                values.flatTaxFrequency = e.target.value
                              }}
                              isrequired='true' />
                          </Col>
                        </>
                      )
                    }
                  </Row>
                } />
              {/* HOTEL_FEES card */}
              { !(this.state.isHotelDomestic === FormConst.VALUE_YES) &&
                <Card
                  id='hotel-fees'
                  header={this.taxesAndChargesLabels.HOTEL_FEES}
                  text={
                    <Row className='justify-content-start'>
                      <Col xs={12} sm={12} md={6} lg={6} xl={4}>
                        <ToggleSwitch
                          id='isHotelFees'
                          name='isHotelFees'
                          label='Do you want to add hotel fees?'
                          checked={values.isHotelFees}
                          value={values.isHotelFees}
                          options={FormConst.SWITCH_OPTIONS_YES_NO}
                          onChange={handleChange} />
                      </Col>

                      {
                        values.isHotelFees &&
                        (
                          <>
                            <Col xs={12} sm={12} md={6} lg={6} xl={4}>
                              <TextInput
                                id='hotel-fees-amount'
                                name='hotelFees'
                                type='number'
                                min='0'
                                step='0.5'
                                max='2500'
                                placeholder='0'
                                label={`Fees Amount* (${this.state.hotelCurrency})`} />
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={6} xl={4} className='wide-item'>
                              <SelectInput
                                id='hotel-fees-frequency'
                                name='hotelFeesFrequency'
                                label='Charge Frequency'
                                options={this.state.chargeFrequencyOptions}
                                onInput={(e) => {
                                  e.preventDefault()
                                  values.hotelFeesFrequency = e.target.value
                                  values.flatTaxFrequency = e.target.value
                                }}
                                isrequired='true' />
                            </Col>
                          </>
                        )
                      }
                    </Row>
                  } />
              }
              <FormFooter
                form={SideNavEntryMapping.HOTEL_CHARGES}
                isSubmit
                submitName={FormConst.SAVE_BUTTON_TEXT}
                resetName={FormConst.RESET_BUTTON_TEXT}
                onReset={this.handleClearForm}
                submitDisabled={isSubmitting} />
              <FormModal
                id='taxes-and-charges-page-loading-modal'
                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                hotelInfo={this.state.hotelInfo}
                body={<h6>{this.state.loadingMessage}</h6>}
                show={this.state.isLoading}
                isLoadingIndicator />
              <FormModal
                id='taxes-and-charges-page-reset-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_RESET_ACTION_TITLE}
                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                proceed={() => {
                  this.resetFormData(resetForm)
                }}
                cancel={() => { this.setState({ showResetModal: false }) }}
                show={this.state.showResetModal} />
              <FormModal
                id='taxes-and-charges-page-error-modal'
                hotelInfo={this.state.hotelInfo}
                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                body={<h5>{this.state.errorMessage}</h5>}
                isError
                cancel={() => { this.setState({ showErrorModal: false }) }}
                show={this.state.showErrorModal} />
            </div>
          </Form>
        )}
      </Formik>
    )
  }
}

// Sample redux dispatch
const mapStateToProps = state => {
  return {
    hotelChargesResponse: state.reducer.response,
    errorMessage: state.reducer.errorMessage,
    errorDescription: state.reducer.errorDescription,
    count: state.reducer.count
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_CHARGES_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(TaxesAndCharges, SideNavEntryMapping.HOTEL_CHARGES))